import React, {lazy, Suspense, useState} from "react";
import Dict from 'dict-lib';
import stylesSCTree from "../SCTree.module.css";
import BUtils from "../../../utilities/BaseUtilities";
import {
    Button,
    Col,
    FormControl,
    Grid,
    Row,
    Label,
    Modal,
    Pagination,
    DropdownButton,
    MenuItem,
    ButtonToolbar,
    SplitButton
} from "react-bootstrap";
import FontAwesome from "react-fontawesome";
import ReactTooltip from "react-tooltip";
import {Typeahead} from "react-bootstrap-typeahead";
import {TreeDOMHelper, TreeNodeHelper, TreeUtilities} from "./TreeHelper";
import InputGroup from "react-bootstrap/es/InputGroup";
import SCCheckbox from "../../checkbox/SCCheckbox";
import scLogo from "../../../../public/img/scLogo.svg";
import {LexemeUtilities} from "../../../lexeme/page/editor/LexemeHelper";
import {AdministrationUtilities} from "../../../administration/AdministrationHelper";
import ReactDOM from "react-dom";
import {TreeAdvancedSearch} from "./TreeAdvancedSearch";
import {TreeAdvancedSearchLegenda} from "./TreeAdvancedSearchLegenda";
import AlignmentButton from "./documentButtons/DocumentButtons";
import _ from "lodash";
import {Notifications} from "../../../utilities/DictUtilities";
import stylesScNavbar from "../../navbar/ScNavbar.module.css";

export class TreeIndexedSearch extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            listItems: [],
            page: 0,
            indexedValueSearch: '',
            openSpecificObject: false,
            openSpecificDate: false,
            openSearchText: false,
            showDocument: false,
            specificObjects: [],
            selectedObject: [],
            specificFields: [],
            prefilledObjects: [],
            selectedField: [],
            selectedSortField: [],
            selectedDate: {from: '', to: ''},
            listDateObjects: [],
            specificFieldsValues: {},
            nPage: 0,
            totalPages: 0,
            pagItems: [],
            isSpecificSearch: false,
            loading: false,
            additionalTitle: '',
            showSortedBy: true,
            showLegenda: false,
            documentButtons: null
        };

        this.isAdvancedSearch = this.props.isAdvancedSearch;
        this.layout = parseInt(Dict.getGlobalProperty('ADVANCED_SEARCH_FIELD_LAYOUT'));
        //this.hasContainerName = TreeNodeHelper.getPropLabel('TREE_PROP_LABEL_DOCUMENT_CONTAINER_NAME') !== null && TreeNodeHelper.getPropLabel('TREE_PROP_LABEL_SUB_ITEM_DOCUMENT_CONTAINER_NAME') !== null;
        this.resultLayout = this.isAdvancedSearch ? parseInt(Dict.getGlobalProperty('ADVANCED_SEARCH_RESULT_LAYOUT')) : 1;
        this.fieldsAdv = Dict.getGlobalProperty('ADVANCED_SEARCH_FIELDS');
        this.hasFieldsAdv = typeof this.fieldsAdv !== 'undefined' && this.fieldsAdv !== null && this.fieldsAdv.length > 0;
        this.isAllSearch = this.hasFieldsAdv && this.fieldsAdv.split('::')[0] === 'ALL';
        this.multipleComposedItems = this.props.composedTreeItems.length > 1;
    }

    componentDidMount() {
        TreeDOMHelper.setSkin();

        if (this.props.simpleSearch !== null && (typeof this.props.indexedSearchQuery !== 'undefined')) {
            this._performSearchByValue(function () {
            });
            this._populateSpecificObjects(function () {
                this._changeSpecificObject(this._getSpecificObject());
            }.bind(this));
        } else {
            this._performOpenSpecificObject();
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        const simpleSearchUpdate = nextProps.simpleSearch != null && nextProps.simpleSearch.filter((item) => {
            return item.checked;
        }).length > 0;

        const val = simpleSearchUpdate && (nextProps.indexedSearchOpen || this.props.indexedSearchOpen);
        return typeof val !== 'undefined' ? val : false;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevProps.indexedSearchOpen || (this.props.indexedSearchQuery !== prevProps.indexedSearchQuery)) {
            if (typeof this.props.indexedSearchQuery === 'undefined') {
                this.setState({listItems: []}, function () {
                    this._performOpenSpecificObject();
                })
            } else {
                this._performSearchByValue();
            }
        }
    }

    _getSpecificObject() {
        if (this.hasFieldsAdv) {
            var selectedObject = null;
            if (this.isAllSearch) {
                selectedObject = 'ALL';
            } else {
                var split = this.fieldsAdv.split('::');
                const objCode = split[0];
                selectedObject = [this.state.specificObjects.find((obj) => {
                    return obj.code === objCode.toUpperCase();
                })];
            }
        }

        if (typeof selectedObject === "undefined")
            selectedObject = [];

        //this.setState({selectedObject});
        return selectedObject;
    }

    _performSearchByValue() {
        var additionalTitle = this.props.docsSearch ? Dict.t('DOCUMENTS') : (this.props.simpleSearch !== null && this.props.simpleSearch.length > 0 ? this.props.simpleSearch.filter((item) => {
            return item.item !== 'DOCS_SEARCH' && item.checked;
        }).map((filtered) => {
            return filtered.label;
        }).join(', ') : '');

        this.setState({listItems: [], loading: true, additionalTitle}, () => {
            this._searchByValue(1, this.props.indexedSearchQuery);
        });
    }

    _performOpenSpecificObject() {
        setTimeout(function () {
            //document.getElementById('indexed-value-search').focus();

            //TODO: dateObject match tutti gli oggetti (composti) che hanno un datepicker. Forse non serve più oppure in modalità ladintal è necessario prima decidere la convenzione del nome data (or su tutti i datepicker esistenti o -soluzione debole- univoco chiamare "data" il campo?)
            //this._populateDateObjects();
            this._populateSpecificObjects();

            //TODO: necessario in fase di caricamento per evitare problemi di asincronia
            this._populatePrefilledFields();

            this.setState({openSpecificObject: true});

            const fieldsAdv = Dict.getGlobalProperty('ADVANCED_SEARCH_FIELDS');
            if (typeof fieldsAdv !== 'undefined' && fieldsAdv !== null && fieldsAdv.length > 0) {

                var split = fieldsAdv.split('::');
                const objCode = split[0];
                var selectedObject = null;
                if (objCode === 'ALL') {
                    selectedObject = 'ALL';
                } else {
                    selectedObject = this.state.specificObjects.find((obj) => {
                        return obj.code === objCode.toUpperCase();
                    });

                    if (typeof selectedObject === "undefined")
                        selectedObject = [];
                    else
                        selectedObject = [selectedObject];
                }

                setTimeout(function () {
                    this._changeSpecificObject(selectedObject);
                    this._showHideSearchFields(1);

                    var focusEl = document.getElementById('indexed-value-search');
                    if (split[1]) {
                        var el = document.getElementById('indexed-value-search-' + split[1]);
                        if (el)
                            focusEl = el;
                    }
                    /*focusEl.focus();*/

                }.bind(this), 300);
            } else {
                setTimeout(() => {
                    this._showHideSearchFields(1);
                }, 300);
            }

        }.bind(this), 300);
    }

    _showHideSearchFields(showVal) {
        var divs = document.getElementsByClassName(stylesSCTree['tree-indexed-search-item__body-col-fields__first__div']);
        for (var i = 0; i < divs.length; i++) {
            divs[i].style.opacity = showVal;
        }
    }

    _emptySearch() {
        var indexedValue = '';
        this.setState({indexedValue});
    }

    _exportResult() {
        Notifications.showModalSpinner(Dict.t('EXPORT_ALIGNMENT_WAIT_MSG'), stylesSCTree['export-long-modal-spinner']);
        this._searchByValue(1, this.props.indexedSearchQuery, true)
    }

    _filterSearchResultItem(item, fieldResultView) {
        if (this.resultLayout === 2) {
            var newItem = '';
            var matchValues = '';
            if (fieldResultView !== '') {
                matchValues = item.listItem.matchValues.filter((item) => {
                    return fieldResultView.includes(item.label);
                });

                matchValues.sort((a, b) => {
                    return fieldResultView.indexOf(a.label) - fieldResultView.indexOf(b.label);
                });
            }

            return newItem;
        } else {
            return item;
        }
    }

    _buildSortedBy(firstField) {
        if (this.isAllSearch) {
            return [firstField];
        } else {
            var sorteBy = this.state.specificFields.filter((field) => {
                return !field.hidden && field.code.toLowerCase() !== firstField.toLowerCase() && !field.startsWith('*');
            }).map((field) => {
                return field.code;
            });

            sorteBy.unshift(firstField);

            return sorteBy;
        }
    }

    _searchByKeyDown() {
        if (this.state.specificFieldsValues !== null)
            this._searchByValue(1);
        else {
            setTimeout(() => {
                this._searchByKeyDown()
            }, 50);
        }
    }

    _resetSortBy(allSortedBy, changeSortField) {
        var firstFieldSort = null;
        var specificFieldsValuesAsArray = [];
        var selectedSortField = [];
        var specificFieldsValues = {};

        specificFieldsValuesAsArray = Object.keys(this.state.specificFieldsValues);
        specificFieldsValuesAsArray.forEach((item) => {
            var value = this.state.specificFieldsValues[item];
            if (typeof value !== 'undefined' && value !== null && value !== '')
                specificFieldsValues[item] = value;
        });
        specificFieldsValuesAsArray = Object.keys(specificFieldsValues);

        if (!this.multipleComposedItems) {
            if (specificFieldsValuesAsArray.length === 1 && typeof changeSortField === 'undefined') {
                firstFieldSort = specificFieldsValuesAsArray[0];
            } else
                firstFieldSort = typeof this.state.selectedSortField === 'undefined' || this.state.selectedSortField.length === 0 ? 'TITLE' : this.state.selectedSortField[0].code;


            var sortedBy = this._buildSortedBy(firstFieldSort);

            if (typeof allSortedBy !== 'undefined') {
                selectedSortField = [this.state.specificFields.find((item) => {
                    return item.code === allSortedBy;
                })];
            } else if (this.state.specificFields.length > 0 && typeof changeSortField === 'undefined' && firstFieldSort !== null) {
                selectedSortField = [this.state.specificFields.find((item) => {
                    return item.code === firstFieldSort;
                })];
            } else if (this.state.selectedSortField.length === 0) {
                selectedSortField = [{label: Dict.t('TITLE'), code: 'TITLE'}];
            } else
                selectedSortField = this.state.selectedSortField;
        } else {
            selectedSortField = [{label: Dict.t('TITLE'), code: 'TITLE'}];
            sortedBy = [selectedSortField[0].label];
        }

        const showSortedBy = typeof allSortedBy === 'undefined';
        sortedBy = JSON.parse(JSON.stringify(sortedBy).replace(/\//g, '_'))

        return {sortedBy, specificFieldsValues, selectedSortField, showSortedBy};
    }

    _searchByValue(nPage, indexedValueSearch, isExport, allSortedBy, changeSortField, callback) {
        var call = '';

        const sortJson = this._resetSortBy(allSortedBy, changeSortField);
        var specificFieldsValues = sortJson.specificFieldsValues;
        var sortedBy = sortJson.sortedBy;

        if (typeof nPage === 'undefined')
            nPage = this.state.nPage;
        if (typeof isExport === 'undefined')
            isExport = false;

        var searchText = (typeof this.props.docsSearch === 'undefined' && this.state.openSearchText) || this.props.docsSearch;

        if (typeof allSortedBy !== "undefined") {
            call = '/tree/searchIndexed/' + this.props.projectName + '/___/' + nPage + '/' + this.state.selectedObject[0].code + '/{}/all/' + this._buildSortedBy(allSortedBy) + '/' + 'AND' + '/' + searchText + '/' + isExport + '/' + true + '/'
        } else if (typeof indexedValueSearch === 'undefined') {
            indexedValueSearch = typeof this.state.indexedValue === 'undefined' || this.state.indexedValue === '' ? '___' : this.state.indexedValue;
            const selectedObject = this.state.selectedObject.length > 0 && this.state.selectedObject !== 'ALL' ? this.state.selectedObject[0].code : "all";

            specificFieldsValues = JSON.parse(JSON.stringify(specificFieldsValues).replace(/\//g, '_'));
            specificFieldsValues = indexedValueSearch.trim() === '___' ? LexemeUtilities.encodeUrl(JSON.stringify(specificFieldsValues)) : '{}';
            searchText = this.state.openSearchText;
            const selectedDate = this.state.selectedDate === {
                from: '',
                to: ''
            } ? "all" : JSON.stringify(this.state.selectedDate);
            call = '/tree/searchIndexed/' + this.props.projectName + '/' + indexedValueSearch + '/' + nPage + '/' + selectedObject + '/' + specificFieldsValues + '/' + selectedDate + '/' + sortedBy + '/' + 'AND' + '/' + searchText + '/' + isExport + '/' + true + '/'
        } else {
            var obj = this.props.simpleSearch;
            if (this.isAllSearch && Array.isArray(this.state.selectedObject) && this.state.selectedObject.length > 0) {
                /*[{"item": "ALL", "field": "TITLE", "checked": true, "label": "titolo"}]*/
                obj = this.state.selectedObject.map((so) => {
                    return {item: so.code, checked: true, field: 'TITLE'};
                });
            }

            var encodedObj = LexemeUtilities.encodeUrl(AdministrationUtilities.encodeOSPath(JSON.stringify(obj)));
            call = '/tree/simpleSearchIndexed/' + this.props.projectName + '/' + nPage + '/' + indexedValueSearch + '/' + encodedObj + '/' + sortedBy + '/' + this.props.docsSearch + '/' + isExport + '/' + true + '/';
        }

        Dict.call(call).then((result) => {
            var fieldResultView = null;
            const selectedObject = this.state.selectedObject;
            if (result.listItems.length > 0 && typeof selectedObject !== 'undefined' && selectedObject.length > 0 /*&& TreeNodeHelper.isSubContainerItem(selectedObject[0].code)*/) {
                if (this.resultLayout === 2) {
                    try {
                        fieldResultView = Dict.getGlobalProperty('ADVANCED_SEARCH_RESULT_FIELDS').split('::')[1].split(',');
                    } catch (error) {
                        console.error(error);
                    }
                }
            }

            if (isExport) {
                Notifications.closeModalSpinner();
                var header = {};
                var headerDataToAdd = null;
                //header['type'] = Dict.t('TYPE').toUpperCase();
                if (fieldResultView === null) {
                    header['title'] = Dict.t('TITLE').toUpperCase();
                    result.listItems[0].data.forEach((dataItem) => {
                        header[dataItem.label] = Dict.t(dataItem.label).toUpperCase();
                    });
                } else {
                    headerDataToAdd = result.listItems[0].data.map(item => {
                        return item.label
                    }).concat('TITLE').filter(item => {
                        return fieldResultView.includes(item);
                    });
                    headerDataToAdd.sort((a, b) => {
                        return fieldResultView.indexOf(a) - fieldResultView.indexOf(b);
                    });
                    headerDataToAdd.forEach((dataItem) => {
                        /*if (dataItem === 'CONTAINER_TITLE') {
                            var container = TreeNodeHelper.getContainerBySubitem(this.state.selectedObject[0].code);
                            header[dataItem] = TreeNodeHelper.getPropLabel(container).toUpperCase();
                        } else*/
                        header[dataItem] = Dict.t(dataItem).toUpperCase();
                    })
                    /*const alignment = result.listItems[0].data.find((itemData) => {
                        return itemData.type === 'alignmentDocs';
                    })*/
                    header['LANG1'] = Dict.getGlobalProperty('ALIGNMENT_TEXT_SEARCH_LABEL_1');
                    header['LANG2'] = Dict.getGlobalProperty('ALIGNMENT_TEXT_SEARCH_LABEL_2');
                    header[Dict.t('LANGUAGES')] = Dict.t('LANGUAGES');
                }

                var ret = result.listItems.map((item) => {
                    var retItem = {};
                    //retItem[item.code] = Dict.t(item.code);
                    var data = item.data;
                    if (fieldResultView !== null) {
                        data = data.filter((itemData) => {
                            return fieldResultView.includes(itemData.label);
                        });

                        const alignment = item.data.find((itemData) => {
                            return itemData.type === 'alignmentDocs';
                        })

                        data.push({
                            label: 'TITLE', value: item.title,
                            lang1: alignment.value.lang1, value1: item.fullTextSearch['testo 1$$$'].join('|'),
                            lang2: alignment.value.lang2, value2: item.fullTextSearch['testo 2$$$'].join('|')
                        });

                        data.sort((a, b) => {
                            return fieldResultView.indexOf(a.label) - fieldResultView.indexOf(b.label);
                        });
                        data.forEach((itemData) => {
                            retItem[itemData.label] = itemData.value;
                            retItem['LANG1'] = itemData.value1;
                            retItem['LANG2'] = itemData.value2;
                        });

                    } else {
                        retItem['TITLE'] = item.title;
                        data.forEach((itemData) => {
                            retItem[itemData.label] = itemData.value;
                        });
                    }

                    retItem[Dict.t('LANGUAGES')] = item.alignedLangs.lang1 + '/' + item.alignedLangs.lang2;

                    return retItem;
                });

                ret = [header].concat(ret);
                TreeUtilities.exportCSV('result', TreeUtilities.convertJsonArrayToCSV(ret));
            } else {
                var listItems = [];
                if (!searchText) {
                    listItems = result.listItems.map((item) => {
                        var rawMatchValues = [{label: 'TITLE', value: item.title}].concat(item.data.filter((datum) => {
                            if (fieldResultView !== null && !fieldResultView.includes(datum.label)) {
                                return false;
                            } /*else if (datum.label === 'CONTAINER_TITLE' || datum.label === 'CONTAINER_DATE') {
                                return true;
                            } */ else {
                                var obj = TreeNodeHelper.getItemByCode(item.code, this.props.composedTreeItems);

                                var retBasicItem = obj.basicItems.find((objItem) => {
                                    return objItem.label === datum.label;
                                });

                                return typeof retBasicItem !== 'undefined' && (typeof retBasicItem.hidden === 'undefined' || !retBasicItem.hidden);
                            }
                        }));

                        var matchValues = rawMatchValues.map((matchValue) => {
                            if (matchValue.code === 'DATE_PICKER')
                                matchValue.value = TreeUtilities.writeDateString(new Date(matchValue.value), 'dd-mm-yyyy');
                            return matchValue;
                        });

                        if (fieldResultView !== null) {
                            matchValues.sort((a, b) => {
                                return fieldResultView.indexOf(a.label) - fieldResultView.indexOf(b.label);
                            });
                        }

                        return {item, matchValues};
                    });
                } else
                    listItems = result.listItems;

                const totalPages = result.totalPages;
                const totalItems = result.totalItems;
                var pagItems = [];
                if (totalPages > 0) {
                    pagItems = this._handleShiftPagination(nPage, totalPages);
                }

                var isSpecificSearch = this.state.selectedObject.length > 0;
                const loading = true;

                var selectedSortField = sortJson.selectedSortField;
                const showSortedBy = sortJson.showSortedBy;
                this.setState({
                    listItems,
                    indexedValueSearch,
                    totalPages,
                    totalItems,
                    pagItems,
                    nPage,
                    isSpecificSearch,
                    loading,
                    selectedSortField,
                    showSortedBy
                }, () => {
                    var objMsg = document.getElementById(this.props.id + '-tree-indexed-search-item__body-no-items-found');
                    if (listItems.length === 0) {
                        var res = result.result;
                        var message = Dict.t('NO_ITEMS_FOUND');
                        var duration = 2000;
                        if (res !== 'OK') {
                            message = result.message;
                            duration = 6000;
                        }
                        objMsg.style.display = 'block';
                        objMsg.innerText = message;
                        if (typeof this.props.indexedSearchQuery === 'undefined') {
                            setTimeout(function () {
                                objMsg.style.display = 'none';
                            }, duration)
                        }
                    } else {
                        objMsg.style.display = 'none';
                    }

                    this.setState({loading: false});
                });

                if (typeof callback === 'function')
                    callback();
            }
        })
    }

    _matchValue(searchText, value) {
        var cleanText = this._buildCleanText(searchText);
        var retValue = "";

        if (searchText.endsWith("*")) {
            retValue = value.startsWith(cleanText) || value.indexOf(" " + cleanText) >= 0;
        } else if (searchText.startsWith("*")) {
            retValue = value.endsWith(cleanText) || value.indexOf(cleanText + " ") >= 0;
        } else {
            retValue = value.indexOf(cleanText) >= 0;
        }

        if (!retValue) {
            const isUpperFirst = searchText[0] === searchText[0].toLowerCase();
            searchText = isUpperFirst ? (value.charAt(0).toUpperCase() + value.slice(1)) : value.toLowerCase();

            return this._matchValue(searchText, value);
        }


        return retValue;
    }

    _buildCleanText(text) {
        return text.replace(/\*/g, '');
    }

    _highlight(text, label) {
        //this.state.indexedValueSearch
        //SON65
        if (typeof label !== 'undefined' && typeof this.state.specificFieldsValues[label] !== 'undefined') {
            var textToClean = this._buildCleanText(this.state.specificFieldsValues[label]);
            var highlightRet = BUtils.highlight(textToClean, text);
            if (highlightRet === text) {
                const isUpperFirst = textToClean[0] === textToClean[0].toLowerCase();
                var newText = isUpperFirst ? (textToClean.charAt(0).toUpperCase() + textToClean.slice(1)) : textToClean.toLowerCase();
                return BUtils.highlight(newText, text);
            } else
                return BUtils.highlight(textToClean, text);
        } else return text;
    }

    _reset() {
        this.setState({
            listItems: [],
            page: 0,
            specificFields: [],
            specificFieldsValues: {}
        })
    }

    _populateSpecificObjects(callback) {
        var subitems = [];
        var openSpecificDate = false;
        var selectedObject = this.state.selectedObject;

        var selectedDate = {from: '', to: ''};
        /*TreeNodeHelper.treeContainersItems.forEach((item) => {
            return subitems = subitems.concat(item.subItems);
        });*/

        /*const containerObjects = this.hasContainerName ? TreeNodeHelper.treeContainersItems.concat(subitems).map(item => {
            var newItem = JSON.parse(JSON.stringify(item));
            newItem.label = TreeNodeHelper.getPropLabel(item);
            return newItem;
        }) : [];*/

        //TODO: eliminazione basicItems
        /*var specificObjects = TreeNodeHelper.treeBasicItems.map(item => {
            var newItem = JSON.parse(JSON.stringify(item));
            newItem.label = Dict.t(item.code);
            return newItem;
        });*/
        var specificObjects = this.props.composedTreeItems.map(item => {
            var newItem = JSON.parse(JSON.stringify(item));
            newItem.label = Dict.t(item.code);
            return newItem;
        });

        //specificObjects = containerObjects.concat(specificObjects);

        var openSpecificObject = !this.state.openSpecificObject;
        if (!openSpecificObject) {
            selectedObject = [];
            this._resetFields();
        }

        this.setState({
            openSpecificObject,
            specificObjects,
            openSpecificDate,
            selectedObject,
            selectedDate
        }, function () {
            if (typeof callback !== 'undefined')
                callback();
        });
    }

    _changeSpecificObject(selectedObject) {
        var openSpecificDate = false;
        var openSearchText = false;
        var oldSelectedObject = this.state.selectedObject;
        //var container = null;
        var hasDateFieldsOrNotSelected = false;
        var listDateObjects = this.state.listDateObjects;
        var specificFields = null;

        if (selectedObject.length > 0) {
            if (selectedObject === 'ALL') {
                const interfaceLanguage = Dict.getGlobalProperty("INTERFACE_LANGUAGE");
                const fieldsAdv = Dict.getGlobalProperty('ADVANCED_SEARCH_FIELDS');

                var fields = fieldsAdv.split('::')[1].split(',');
                specificFields = [];
                fields.forEach((field) => {
                    if (field.startsWith('$')) {
                        var i18n = Dict.t(field.replace('$', ''));
                        var dateField = {label: i18n, code: i18n, type: 'datepicker'};
                        specificFields.push(dateField);
                        openSpecificDate = true;
                    } else if (field.startsWith('*')) {
                        //var i18n = Dict.t(field.replace('#', ''));
                        //field = field.replace('#', '');
                        var docField = {label: field, code: field, type: 'document'};
                        specificFields.push(docField);
                        openSpecificDate = true;
                    } /*else if (field.startsWith('*')) {
                        Dict.call('/tree/prefillObject/' + this.props.projectName + '/' + field.replace('*', '') + '/').then((result) => {
                            console.log();
                        });
                        //specificFields.push({label: field, type: basicItem.item.element.type, code: field, });
                    }*/ else {
                        this.props.composedTreeItems.find((item) => {
                            return item.basicItems.find((basicItem) => {
                                if (basicItem.i18nLabels[interfaceLanguage] === field.trim()) {
                                    specificFields.push({label: field, type: basicItem.item.element.type, code: field});
                                    return true;
                                } else
                                    return false;
                            });
                        });
                    }
                });
            } else {
                var selectedItem = TreeNodeHelper.getItemByCode(selectedObject[0].code, this.props.composedTreeItems);
                specificFields = selectedItem.basicItems.filter((item) => {
                    return item.type === 'textfield' || item.type === 'tinymce';
                }).map(item => {
                    return {label: Dict.t(item.label), type: item.type, code: item.label, hidden: item.hidden};
                });

                //container = TreeNodeHelper.getContainerBySubitem(selectedItem.code);

                /*if (this.layout === 1 && typeof container !== 'undefined' && container != null) {
                    var datePickerContainer = container.basicItems.find((item) => {
                        return item.type === 'datepicker';
                    });

                    var containerFields = [{
                        label: (TreeNodeHelper.getPropLabel(container)),
                        code: 'CONTAINER_TITLE'
                    }];

                    if (datePickerContainer) {
                        containerFields.push({label: 'DATE', code: 'DATE'});
                    }

                    containerFields = containerFields.map((containerItem, index) => {
                        var label = index > 0 ? Dict.t(containerItem.label) : containerItem.label;
                        var code = containerItem.code;
                        var containerCode = container.code;
                        var containerFieldsSize = containerFields.length;
                        return {label, code, containerCode, containerFieldsSize}
                    });

                    specificFields = containerFields.concat(specificFields);
                }*/

                var foundDateItems = selectedObject.filter((obj) => {
                    return listDateObjects.indexOf(obj.label) >= 0;
                });

                /*if (foundDateItems.length === 0 && container !== null) {
                    if (listDateObjects.indexOf(container.code) >= 0)
                        foundDateItems.push(container);
                }*/

                hasDateFieldsOrNotSelected = foundDateItems.length > 0;
            }
        } else {
            specificFields = [];
        }

        var selectedSortField = [{label: Dict.t('TITLE'), code: 'TITLE'}];
        specificFields = selectedSortField.concat(specificFields);

        this.setState({
            openSpecificDate,
            openSearchText,
            specificFields,
            selectedSortField,
            selectedObject,
            hasDateFieldsOrNotSelected
        }, () => {
            if (oldSelectedObject.length > 0 && oldSelectedObject !== selectedObject)
                this._resetFields();
        });
    }

    _changeComposedItem(item) {
        var selectedObject = '';

        if (item[0].code === Dict.t('ALL_ITEMS_SIMPLE'))
            selectedObject = 'ALL';
        else if (item.length > 0) {
            selectedObject = item;
            selectedObject.label = item[0].label
        }

        const searchResultCol = document.getElementsByClassName(stylesSCTree["tree-indexed-search-item__body-col-results"])[0];
        searchResultCol.style.visibility = "hidden";
        this.setState({
            selectedObject,
        }, () => {
            this._searchByValue(this.state.nPage, this.props.indexedSearchQuery, undefined, undefined, undefined, () => {
                setTimeout(
                    function () {
                        searchResultCol.style.visibility = "visible";
                    }, 500);

            });
        });
    }

    _changeSortedField(item) {

        var selectedSortField = [];
        if (item.length > 0) {
            selectedSortField = item;
            selectedSortField.label = [typeof item[0].code === 'undefined' ? item[0].label : Dict.t(item[0].code)]
        }

        const searchResultCol = document.getElementsByClassName(stylesSCTree["tree-indexed-search-item__body-col-results"])[0];
        searchResultCol.style.visibility = "hidden";
        this.setState({
            selectedSortField,
        }, () => {
            const listItems = this.state.listItems;
            if (typeof listItems !== 'undefined' && listItems.length > 0) {
                this._searchByValue(this.state.nPage, this.props.indexedSearchQuery, undefined, undefined, selectedSortField[0].code, () => {
                    searchResultCol.style.visibility = "visible";
                });
            }
        });
    }

    _populatePrefilledFields() {
        const prefilledFields = Dict.getGlobalProperty('PREFILLED_FIELDS');
        var prefilledObjects = [];
        if (typeof prefilledFields !== 'undefined' && prefilledFields !== null && prefilledFields !== '') {
            var prefilledFieldsSplit = prefilledFields.split('|');
            prefilledFieldsSplit.forEach((prefilledItem) => {
                var prefilledObject = {
                    prefilledItem: prefilledItem.split('::')[0].toUpperCase(),
                    prefilledFields: prefilledItem.split('::')[1],
                    selected: []
                };
                prefilledObjects.push(prefilledObject);
            });
        }

        if (prefilledObjects.length > 0) {
            //TODO: solo collezioni richieste? ma avrebbe senso avere collezioni non cercabili?
            const prefilledStr = LexemeUtilities.encodeUrl(AdministrationUtilities.encodeOSPath(JSON.stringify(prefilledObjects)));
            //Dict.call('/tree/prefillObjects/' + this.props.projectName + '/' + prefilledStr + '/').then((result) => {
            if (prefilledObjects.length > 0 && prefilledObjects[0].prefilledFields.split(',').length > 0) {
                prefilledObjects[0].prefilledFields.split(',').forEach((itemField, index) => {
                    const foundCollection = this.props.composedCollections.find((collection) => {
                        return itemField === Dict.t(collection.label);
                    })

                    if (typeof foundCollection !== 'undefined') {
                        const items = foundCollection.items;
                        prefilledObjects[0][itemField] = {
                            selected: [], items: items.map((comboItem) => {
                                var newComboItem = {};
                                newComboItem.code = comboItem.id + '';

                                if (comboItem.label.startsWith('noI18n:')) {
                                    newComboItem.label = comboItem.label.replace('noI18n:', '').replace('_', ' ');
                                    newComboItem.originalLabel = comboItem.label;
                                } else {
                                    newComboItem.label = Dict.t(comboItem.label);
                                    newComboItem.originalLabel = comboItem.label;
                                }

                                return newComboItem;
                            }).sort(function (a, b) {
                                if (a.label.indexOf('__') >= 0)
                                    return 1;
                                else {
                                    const aLabel = a.label.startsWith('noI18n:') ? a.label.replace('noI18n:', '').replace('_', ' ') : Dict.t(a.label);
                                    const bLabel = b.label.startsWith('noI18n:') ? b.label.replace('noI18n:', '').replace('_', ' ') : Dict.t(b.label);

                                    return aLabel > bLabel ? 1 : -1;
                                }
                            })
                        };
                    }
                });

                this.setState({prefilledObjects}, () => {
                });
            }
            //})
        }
    }

    _populateDateObjects() {
        var listDateObjects = typeof this.props.composedTreeItems === 'undefined' ? [] : BUtils.cloneJson(this.props.composedTreeItems);

        this.setState({listDateObjects});
    }

    _checkAndBuildDocumentButtons() {
        /*var pathExists = true;
        const modulePath = this.props.projectName;
        var completePath = 'service/documentButtons/' + modulePath + '/DocumentButtons';
        try {
            //require('./service/documentButtons/' + modulePath + '/DocumentButtons');
            require('./' + completePath);
        } catch (ex) {
            pathExists = false;
        }

        const alignmentActive = Dict.getGlobalProperty('ACTIVE_DOC_ALIGNMENT');

       // if (pathExistsalignmentActive === 'true') {
            try {


                setTimeout(() => {
                    //const MyLazyComponent = React.lazy(() => import('./' + completePath));
                    //const MyLazyComponent = <DocumentButtons/>;

                    const MyComponent = () => {
                        return <Suspense fallback={<div>Loading...</div>}>
                            <MyLazyComponent/>
                        </Suspense>
                    };

                    //const rootElement = document.getElementById("tree-modal-dynamic-buttons");
                    //ReactDOM.render(<MyComponent/>, rootElement);


                }, 200);


                const rootElement = document.getElementById("tree-modal-dynamic-buttons");
                const MyComponent = AlignmentButton();
                ReactDOM.render(MyComponent, rootElement);

            } catch (e) {
                console.log();
            }
        }*/
    }

    _openSpecificDate() {
        var openSpecificDate = !this.state.openSpecificDate;
        this.setState({
            openSpecificDate
        })
    }

    _openSearchText(newState) {
        this._resetOpen();

        var openSearchText = newState;
        var openSpecificDate = false;
        var openSpecificObject = false;

        this.setState({openSearchText, openSpecificDate, openSpecificObject});
    }

    _resetOpen() {
        var specificFields = [];
        var specificFieldsValue = {};
        var selectedSortField = [];
        var specificField = [];
        var selectedObject = [];
        var hasDateFieldsOrNotSelected = false;
        var selectedDate = {from: '', to: ''};
        var listItems = [];

        this.setState({
            specificFields,
            specificField,
            selectedSortField,
            selectedObject,
            selectedDate,
            specificFieldsValue,
            listItems,
            hasDateFieldsOrNotSelected
        });
    }

    _resetFields() {
        var specificFields = [];
        var specificFieldsValues = {};
        this.setState({specificFields, specificFieldsValues});
    }

    _fillYearTo(evt, isFrom) {
        var selectedDate = this.state.selectedDate;

        if (isFrom) {
            selectedDate.from = evt.target.value;
        } else
            selectedDate.to = evt.target.value;
    }

    _handlePagination(eventKey) {
        if (eventKey > 0) {
            this.setState({
                nPage: eventKey
            }, () => {
                if (this.props.docsSearch) {
                    this.setState({listItems: [], loading: true})
                }
                this._searchByValue(this.state.nPage, this.props.indexedSearchQuery);
            });
        }
    }

    _handleShiftPagination(nPage, totalPages) {
        var pagItems = [];
        var drawButton = true;

        for (let number = 1; number <= totalPages; number++) {
            if (nPage <= 2 && number <= 3) {
                drawButton = true;
            } else {
                var abs = Math.abs(number - nPage);

                if (nPage >= 3 && abs < 2) {
                    drawButton = true;
                } else {
                    drawButton = false;
                }
            }

            if (drawButton) {
                pagItems.push(
                    <Pagination.Item active={number === nPage} key={'key-page-item-' + number}
                                     onClick={() => this._handlePagination(number)}>{number}</Pagination.Item>)
            }

            drawButton = true;
        }

        return pagItems;
    }

    //TODO: di nosha, trovare il modo di toglierlo
    _retrieveMatchedResults(matchValues, item) {
        matchValues.map((matchValue, index) => {
            if (this.resultLayout === null || this.resultLayout === 1) {
                if (matchValue.label !== 'TITLE') {
                    var id = item.key + "-" + matchValue.label + "-" + index;
                    var printLabel = Dict.t(matchValue.label);

                    /*if (matchValue.label === 'CONTAINER_TITLE') {
                        printLabel = TreeNodeHelper.getPropLabel(container);
                    }*/

                    return <span className={stylesSCTree['result-tree-index-item__match__container']}>
                    <span
                        className={stylesSCTree['result-tree-index-item__match__label']}>{printLabel + ":"}</span>
                    <span className={stylesSCTree['result-tree-index-item__match__value']} id={id}
                          dangerouslySetInnerHTML={{__html: this._highlight(matchValue.value, matchValue.label)}}/>
                </span>;
                }
            } else {
                const isSortField = this.state.selectedSortField.length > 0 && matchValue.label === this.state.selectedSortField[0].code
                var openTag = isSortField ? '<strong>' : '';
                var closeTag = isSortField ? '</strong>' : '';

                return <span
                    className={stylesSCTree['result-tree-index-item__match-value-item-layout-' + this.resultLayout]}
                    dangerouslySetInnerHTML={{__html: openTag + this._highlight(matchValue.value, matchValue.label) + closeTag}}/>
            }
        });

        var openButtons = "";
        if (this.state.openSearchText || typeof listItem.pages !== 'undefined') {
            var listToMap = listItem.pages.length > 5 ? listItem.pages.slice(0, 5) : listItem.pages;

            openButtons = listToMap.map((page) => {
                return <Button style={{marginRight: '4px'}} onClick={() => {
                    this.props.callbackOpenTextIndexedSearch(item, page);
                    this.setState({showDocument: true});

                }}>{'pag.' + page}</Button>
            });

        } else {
            openButtons = [];
        }

        return <div
            className={BUtils.joinClasses(stylesSCTree['result-tree-index-item'], stylesSCTree['result-tree-index-item--' + ((index + 1) % 2 === 0 ? 'even' : 'odd')])}>
                    <span className={stylesSCTree['result-tree-index-item__data']} onClick={() => {
                        this.props.callbackOpenItem(item);
                    }
                    }>
                        {this.resultLayout === null || this.resultLayout === 1 ? <><span
                            className={stylesSCTree['result-tree-index-item__tooltip']}>
                        <FontAwesome
                            className={'ooo'}
                            data-tip data-for={'tooltip-advanced-item-code-' + index}
                            name={this.props.itemsToIcon[item.code]}/>
                        <ReactTooltip id={'tooltip-advanced-item-code-' + index} type='info' delayShow={20}
                                      className={"tree-tool-tip"}>{Dict.t(item.code)}</ReactTooltip>
                        </span>
                            <span
                                className={BUtils.joinClasses(stylesSCTree['result-tree-index-item__descr'], stylesSCTree['result-tree-index-item__descr__no-match--' + (matchValuesDiv === '')])}
                                dangerouslySetInnerHTML={{__html: this._highlight(item.title)}}/>
                        </> : ''}
                        <span
                            className={BUtils.joinClasses(stylesSCTree['result-tree-index-item__match-value'], stylesSCTree['result-tree-index-item__match-value--' + (matchValuesDiv !== '')])}>{matchValuesDiv}</span>
                    </span>
            <span className={stylesSCTree['result-tree-index-item__button']}>
                    {openButtons}
                    </span>
        </div>;
    }

    _drawResult() {
        //var container = null;
        const selectedObject = this.state.selectedObject;
        const listItems = this.state.listItems;
        const hasListItems = typeof listItems !== 'undefined' && listItems.length > 0;

        //if (!this.props.docsSearch && hasListItems && typeof selectedObject !== 'undefined' && selectedObject.length > 0 /*&& TreeNodeHelper.isSubContainerItem(selectedObject[0].code)*/) {
        //    container = TreeNodeHelper.getContainerBySubitem(selectedObject[0].code);
        //}
        const resultContainer = document.getElementById('tree-indexed-search-item__body-col-results__overview');

        var result = '';
        if (this.state.loading) {
            result = hasListItems ? listItems.map((listItem, index) => {
                const item = listItem.item;

                if (this.isAllSearch) {
                    return this._retrieveAllSearchResults(item);
                } else {
                    const openSearchText = this.state.openSearchText;
                    var matchValues = listItem.matchValues;

                    if (container !== null) {
                        const toIndex = 2;
                        const fromIndex = matchValues.findIndex((item) => {
                            return item.label === 'CONTAINER_TITLE';
                        });
                        const element = matchValues.splice(fromIndex, 1)[0];
                        matchValues.splice(toIndex, 0, element);
                    }
                    return (openSearchText || typeof listItem.pages !== 'undefined' || matchValues.length === 1) ?
                        '' : this._retrieveMatchedResults(matchValues, item);
                }
            }) : '';

            ReactDOM.render(<>{result}</>, resultContainer);
        }

        return hasListItems;
    }

    _retrieveAllSearchResults(item) {

        //LEGACY
        if (typeof item.data.find((itemData) => {
            return itemData.type === 'alignmentDocs'
        }) !== null) {
            const docsLabel = this.state.specificFields.filter((specificField) => {
                return specificField.code.startsWith('*');
            });
            const alignItem = _.remove(item.data, (dataInd) => {
                return dataInd.type === 'alignmentDocs';
            })[0];

            var docsAlign = docsLabel.map((doc) => {
                try {
                    var file = alignItem.value['file' + doc.code.split(' ')[1].replace('$$$', '')]
                    var filename = BUtils.extractFilenameNoExtension(file);
                    var extension = BUtils.extractFileExtension(file);

                    return {
                        label: doc.label.replace('*', ''),
                        type: 'dropzone',
                        code: 'DOCUMENTS',
                        value: [{filename, extension}],
                        folder: item.key,
                        basicItemHidden: false
                    }
                } catch (error) {
                    Notifications.showErrorModalMessage("ignore:errore riscontrato in id:" + item.key + ' - titolo:' + item.title, 3000);
                }
            });
            item.data = item.data.concat(docsAlign)
        }


        var title = <div className={stylesSCTree['tree-indexed-all-search-result-row-title__div']}>
            <span onClick={() => {
                this.props.callbackOpenItem(item);
            }
            }>{item.title}</span>
        </div>;

        var code = <div className={stylesSCTree['tree-indexed-all-search-result-row-code__div']}>
            <span>({Dict.t(item.code)})</span>
        </div>;

        var preview = '';
        var dataItemElements = item.data.filter((dataItem) => {
            return (dataItem.type === 'textfield' || dataItem.type === 'datepicker' || dataItem.type === 'dropzone' || dataItem.type === 'tinymce' || dataItem.type === 'autocomplete' || dataItem.type === 'dropzone' /*|| dataItem.type === 'alignmentDocs'*/);
        }).map((dataItem) => {
            var value = '-';
            if (dataItem.type === 'dropzone' && dataItem.code === 'IMAGE_GALLERY') {
                if (dataItem.value.length > 0) {
                    var src = BUtils.getServerUrl() + '/tree/getMultimedia/' + this.props.projectName + '/' + dataItem.folder + '/' + dataItem.value[0].extension + '/' + dataItem.value[0].filename + '/';

                    preview = <div className={stylesSCTree['tree-object-viewer__carousel-container']}>
                        <img className={stylesSCTree['tree-object-viewer__carousel-container-img']} src={src}
                             alt={'no img'}/>
                    </div>
                }
            } else if (dataItem.type === 'dropzone' && dataItem.code === "DOCUMENTS") {
                var labelNoBlankSpace = dataItem.label.indexOf('$$$') >= 0 ? dataItem.label : dataItem.label.replace(/ /g, '_');
                var labelWithLang = dataItem.label;

                var otherFilename = '';
                var otherLabel = '';
                var isDirect = dataItem.label.endsWith('1$$$');
                if (labelNoBlankSpace.endsWith('$$$')) {
                    labelWithLang = labelNoBlankSpace.replace('1$$$', item.alignedLangs.lang1).replace('2$$$', item.alignedLangs.lang2);
                    var otherDataItemDoc = item.data.find((other) => {
                        return other.label.endsWith('$$$') && other.label !== dataItem.label
                    });
                    otherFilename = otherDataItemDoc.value[0].filename;
                    otherLabel = otherDataItemDoc.label;
                }

                dataItem.viewLabel = labelWithLang;

                var jsArray = item.fullTextSearch[labelNoBlankSpace];
                if (typeof jsArray === 'undefined')
                    jsArray = ['$ALL'];

                var word = this.state.specificFieldsValues['*' + dataItem.label];
                if (typeof word !== 'undefined' && typeof jsArray !== 'undefined' && word.indexOf('*') >= 0) {
                    word = word.replace(/\*/g, '');
                    var searchOn = true;
                    var substr = jsArray[0].toLowerCase().split(word)[1];
                    if (typeof substr !== 'undefined') {
                        substr.split('').forEach((c) => {
                            if (searchOn && /[\p{L}\p{N}]/u.test(c)) {
                                word += c;
                            } else {
                                searchOn = false;
                            }
                        });
                    }
                }

                value = typeof jsArray !== 'undefined' ? jsArray.map((jsaItem, position) => {
                    var classToMark = labelNoBlankSpace.replace(/ /g, '_').replace('$$$', '_') + dataItem.folder + position;
                    var wordPosition = jsaItem === '$ALL' ? undefined : {word, position};
                    setTimeout(function () {
                        TreeDOMHelper.markElementText("." + classToMark, word, stylesSCTree["tree-markYellow"]);
                    }, 0);
                    return <div style={{fontSize: '13px'}}
                                className={BUtils.joinClasses(classToMark, stylesSCTree['tree-document-open-search-result'])}
                                onClick={() => {
                                    this.setState({showDocument: true},
                                        () => {
                                            TreeDOMHelper.performOpenDocumentPreview(undefined, undefined, undefined, this.props.projectName, item.key, 'tree-modal-doc-body-indexed-search', 'tree-modal-alignment-buttons', dataItem.value[0].filename, dataItem.value[0].extension, 1, dataItem.label, wordPosition, otherFilename, otherLabel, isDirect);
                                            /*if (typeof wordPosition !== 'undefined')
                                                this._checkAndBuildDocumentButtons();*/
                                        });
                                }}
                                dangerouslySetInnerHTML={{__html: (jsaItem === '$ALL' ? Dict.t('OPEN') : jsaItem)}}/>;
                }) : '';
            } else if (dataItem.type === 'alignmentDocs' && dataItem.code === "ALIGNMENT_DOCS") {
                const docsLabel = this.state.specificFields.filter((specificField) => {
                    return specificField.code.startsWith('*');
                })

                docsLabel.forEach((docLabel) => {
                    const realLabel = docLabel.label.replace('*', '');
                    if (typeof item.fullTextSearch[realLabel] === 'undefined') {
                        item.fullTextSearch[realLabel] = ['$ALL'];
                    }
                })

                value = Object.keys(item.fullTextSearch).map((itemTextSearch, index) => {
                    dataItem.label = itemTextSearch;
                    var labelNoBlankSpace = dataItem.label.indexOf('$$$') >= 0 ? dataItem.label : dataItem.label.replace(/ /g, '_');
                    var labelWithLang = dataItem.label;

                    var filenameComplete = dataItem.value['file' + labelNoBlankSpace.split(' ')[1].replace('$$$', '')];
                    var filename = BUtils.extractFilenameNoExtension(filenameComplete);
                    var extension = BUtils.extractFileExtension(filenameComplete);

                    if (labelNoBlankSpace.endsWith('$$$')) {
                        //filename = dataItem.value['file' + labelNoBlankSpace.split(' ')[1].replace('$$$', '')];
                        const filenameSplit = filename.split('_');
                        const replaceText = filenameSplit[filenameSplit.length - 1];
                        labelWithLang = labelNoBlankSpace.replace('1$$$', replaceText).replace('2$$$', replaceText);
                    }

                    dataItem.viewLabel = labelWithLang;

                    var word = this.state.specificFieldsValues['*' + itemTextSearch];
                    var jsArray = item.fullTextSearch[itemTextSearch];
                    /*if (typeof jsArray === 'undefined')
                        jsArray = ['$ALL'];*/
                    if (typeof word !== 'undefined' && typeof jsArray !== 'undefined' && word.indexOf('*') >= 0) {
                        word = word.replace(/\*/g, '');
                        var searchOn = true;
                        var substr = jsArray[0].toLowerCase().split(word)[1];
                        if (typeof substr !== 'undefined') {
                            substr.split('').forEach((c) => {
                                if (searchOn && /[\p{L}\p{N}]/u.test(c)) {
                                    word += c;
                                } else {
                                    searchOn = false;
                                }
                            });
                        }
                    }

                    return typeof jsArray !== 'undefined' ? jsArray.map((jsaItem, position) => {
                        var classToMark = itemTextSearch.replace(/ /g, '_').replace('$$$', '_') + item.key + position;
                        var wordPosition = jsaItem === '$ALL' ? undefined : {word, position};
                        setTimeout(function () {
                            TreeDOMHelper.markElementText("." + classToMark, word, stylesSCTree["tree-markYellow"])
                        }, 0);
                        return <div style={{fontSize: '13px'}}
                                    className={BUtils.joinClasses(classToMark, stylesSCTree['tree-document-open-search-result'])}
                                    onClick={() => {
                                        this.setState({showDocument: true},
                                            () => {
                                                TreeDOMHelper.performOpenDocumentPreview(undefined, undefined, undefined, this.props.projectName, item.key, 'tree-modal-doc-body-indexed-search', 'tree-modal-alignment-buttons', dataItem.value[0].filename, extension, 1, dataItem.label, wordPosition);
                                            });
                                    }}
                                    dangerouslySetInnerHTML={{__html: (jsaItem === '$ALL' ? Dict.t('OPEN') : jsaItem)}}/>;
                    }) : '';
                });
            } else if (dataItem.type === 'autocomplete') {
                if (dataItem.itemIdSelected > 0) {
                    const collection = TreeUtilities.extractItemsByComposedCollection(dataItem.collectionId, this.props.composedCollections);
                    var itemLabel = Dict.t(collection.items.find((acItem) => {
                        return acItem.id + '' === dataItem.itemIdSelected + '';
                    }).label);
                    if (itemLabel.startsWith('_noI18n:')) {
                        value = itemLabel.substring(0, itemLabel.length - 1).replace('_noI18n:', '').replace('_', ' ');
                    } else {
                        value = itemLabel;
                    }
                }
            } else {
                if (typeof dataItem.value !== 'undefined' && dataItem.value.trim() !== '') {
                    if (dataItem.type === 'datepicker') {
                        value = TreeUtilities.writeDateString(new Date(dataItem.value), 'dd-mm-yyyy');
                    } else {
                        value = dataItem.value;
                    }
                }
            }


            return <div className={stylesSCTree['tree-indexed-all-search-result-row__div']}>
                <span
                    className={stylesSCTree['tree-indexed-all-search-result-row__label']}
                    dangerouslySetInnerHTML={{__html: typeof dataItem.viewLabel !== 'undefined' ? dataItem.viewLabel : dataItem.label + ':&nbsp;'}}/>
                <span className={stylesSCTree['tree-indexed-all-search-result-row__value']}>{value}</span>
            </div>
        });

        return <Row className={stylesSCTree['tree-indexed-all-search-result-row']}><Col lg={8}
                                                                                        md={8}>{title}{code}{dataItemElements}</Col><Col
            lg={4} md={4}>{preview}</Col></Row>
    }

    render() {


        var hasResult = this._drawResult();

        var filter = (!hasResult && (this.state.nPage === 0 || !this.isAllSearch)) || this.state.openSearchText || this.props.docsSearch ? '' :
            <div className={stylesSCTree['result-tree-index-item__filter']}>
                {this.state.isSpecificSearch ? <Button style={{marginLeft: '5px'}} onClick={() => {
                    this._exportResult();
                }}>{Dict.t('EXPORT')}
                </Button> : ''}
                {this.state.showSortedBy ?
                    <div id={'tree-indexed-search-filter-th-container'} style={{visibility: 'visible'}}>
                        <h4 id='tree-indexed-search-filter-label'
                            style={{display: 'inline', marginLeft: '15px', marginRight: '3px'}}>
                            <Label bsStyle={'primary'}
                                   className={stylesSCTree['tree-indexed-search-filter-label']}>{Dict.t(this.isAllSearch && this.multipleComposedItems ? 'FILTER' : 'ORDER_BY')}:</Label>
                        </h4>
                        {this.isAllSearch && this.multipleComposedItems ? <ButtonToolbar
                                bsSize="medium"
                                id="dropdown-size-medium-field-filter"
                            >
                                <SplitButton
                                    title={this.state.selectedObject === 'ALL' ? Dict.t('ALL_ITEMS_SIMPLE') : this.state.selectedObject[0].code}
                                    dropup
                                    id="split-button-dropup-pull-right"
                                >
                                    {[{
                                        code: Dict.t('ALL_ITEMS_SIMPLE'),
                                        label: Dict.t('ALL_ITEMS_SIMPLE')
                                    }].concat(this.props.composedTreeItems).map((item, index) => {
                                        return <MenuItem eventKey={index} onSelect={() => {
                                            this._changeComposedItem([item])
                                        }}>{index === 0 ? item.label : item.code}</MenuItem>
                                    })}
                                </SplitButton>
                            </ButtonToolbar> :
                            <ButtonToolbar
                                bsSize="medium"
                                id="dropdown-size-medium-field-filter"
                            >
                                <SplitButton
                                    title={this.state.selectedSortField[0].label.startsWith('*') ? Dict.t('CHOOSE') : this.state.selectedSortField[0].label}
                                    dropup
                                    id="split-button-dropup-pull-right"
                                >
                                    {this.state.specificFields.filter((field) => {
                                        return (typeof field.hidden === 'undefined' || !field.hidden) && (!field.label.startsWith('*'));
                                    }).map((selectedSortField, index) => {
                                        return <MenuItem eventKey={index} onSelect={() => {
                                            this._changeSortedField([selectedSortField]);
                                        }}>{selectedSortField.label}</MenuItem>
                                    })}
                                </SplitButton>
                            </ButtonToolbar>}
                    </div> : ''}
            </div>;


        const hasIndexedSearchQuery = typeof this.props.indexedSearchQuery !== 'undefined';

        var selectedObjectFields = '';
        var showIndexButton = [];

        if (typeof this.state.specificFields !== 'undefined' && this.state.specificFields.length > 0) {
            var containerSize = this.state.specificFields[0].containerFieldsSize;
            const hasContainer = typeof containerSize !== 'undefined';

            selectedObjectFields = this.state.specificFields.filter((field) => {
                return !field.hidden;
            }).map((field, index) => {
                var fieldToId = field.code;
                var isContainer = hasContainer && index < containerSize;
                var label = '';
                var additionalInputGroup = '';
                var fieldLabel = (isContainer ? 'CONTAINER_' : '') + field.label;
                var isDatePicker = field.code === 'DATE_PICKER' || field.code === 'DATE' || field.type === 'datepicker';
                var isDocument = field.type === 'document';
                var addonLabel = '';

                if (hasContainer && this.layout === 1) {
                    var labelAdditionalText = (index === containerSize ? TreeNodeHelper.getPropLabel(this.state.selectedObject[0]) : '');
                    label = labelAdditionalText !== '' ?
                        <h4 style={{marginTop: '7px', marginBottom: 0}}><Label
                            bsStyle="primary">{Dict.t('FIELDS') + ' ' + labelAdditionalText}</Label></h4> : ''
                }

                if (isDatePicker) {
                    //var to_fieldLabel = (isContainer ? 'CONTAINER_' : '') + 'TO';
                    additionalInputGroup = <InputGroup
                        className={BUtils.joinClasses(stylesSCTree["input-group-indexed-search-date"], stylesSCTree['input-group-indexed-search-date--' + this.state.openSpecificDate])}>
                        <InputGroup.Addon key={"key-ref-create-entry"}
                                          style={{
                                              fontWeight: 'bold',
                                              minWidth: '100px',
                                              fontSize: '12px',
                                              height: '10px',
                                          }}>{Dict.t('TO')}</InputGroup.Addon><FormControl
                        id={'indexed-value-search-' + fieldToId}
                        type="number"
                        style={{width: '100%'}}
                        placeholder={Dict.t('SEARCH')}
                        value={isDatePicker ? this.state.selectedDate.to : (typeof this.state.specificFieldsValues[fieldLabel] !== 'undefined' ? this.state.specificFieldsValues[fieldLabel] : '')}
                        ref={(input) => {
                            this['indexSearch' + field.code] = input;
                        }}
                        disabled={typeof this.state.indexedValue !== 'undefined' && this.state.indexedValue !== ''}
                        onChange={(evt) => {
                            var selectedDate = this.state.selectedDate;
                            selectedDate.to = evt.target.value;
                            this.setState({selectedDate})
                        }}
                        onKeyDown={(evt) => {
                            if (evt.keyCode === 13) {
                                this._searchByValue(1);
                            }
                        }}
                    /></InputGroup>;

                    addonLabel = Dict.t('FROM');
                } else {
                    if (isDocument && fieldLabel.indexOf('$$$') >= 0) {
                        addonLabel = "*" + Dict.getGlobalProperty('ALIGNMENT_TEXT_SEARCH_LABEL_' + (fieldLabel.indexOf('1') >= 0 ? '1' : '2'));
                    } else
                        addonLabel = field.label.startsWith('*') ? field.label.replace('$$$', '') : field.label;
                }

                var elementSearch = '';
                const prefilledObjects = this.state.prefilledObjects;
                const selectedObject = this.state.selectedObject;
                const hasSelAndPred = prefilledObjects.length > 0 && selectedObject.length > 0;
                var additionalClassGroupIndexedSearchComplete = '';
                if (hasSelAndPred && typeof prefilledObjects[0][field.code] !== 'undefined') {
                    //if (hasSelAndPred /* && prefilledObjects[0].prefilledItem === selectedObject[0].code */ && fieldToId === prefilledObjects[0].prefilledField) {
                    const prefilledCollection = prefilledObjects[0][field.code];
                    elementSearch = <><Typeahead
                        id={'tree-indexed-search-specific-' + fieldToId}
                        key={'key-search-element-' + fieldToId}
                        ref={(ref) => this['specObject_' + field.code] = ref}
                        maxResults={5}
                        /*minLength={1}*/
                        paginationText={Dict.t('DISPLAY_ADDITIONAL_RESULTS')}
                        className={BUtils.joinClasses(stylesSCTree['tree-indexed-search-specific-element'])}
                        clearButton={false}
                        onChange={(selectedObject, evt) => {
                            var prefilledObjects = this.state.prefilledObjects;
                            var specificFieldsValues = this.state.specificFieldsValues;
                            const prefilledCollection = prefilledObjects[0][field.code];
                            if (selectedObject.length > 0) {
                                specificFieldsValues[field.code] = selectedObject[0].code;//selectedObject[0].originalLabel;
                                prefilledCollection.selected = selectedObject;
                            } else {
                                //delete specificFieldsValues[field.code];
                                specificFieldsValues = this.state.specificFieldsValues;
                                prefilledCollection.selected = [];
                            }

                            this.setState({specificFieldsValues, prefilledObjects})
                        }}

                        /*onFocus={(rr) => {
                            console.log();
                        }}*/

                        onInputChange={(text, evt) => {
                            var listItems = this.state.listItems;
                            var specificFieldsValues = this.state.specificFieldsValues;
                            specificFieldsValues[field.code] = text;
                            this.setState({specificFieldsValues, listItems})
                        }}

                        onKeyDown={(evt) => {
                            if (evt.keyCode === 13) {
                                setTimeout(() => {
                                    this._searchByKeyDown();
                                }, 1000);
                            }
                        }
                        }
                        /*onSearch={() => {
                            return;
                        }}*/
                        options={prefilledCollection.items}
                        selected={prefilledCollection.selected}
                        placeholder={Dict.t('SEARCH') + "..."}
                    />
                        <div style={{textAlign: 'right', marginBottom: '35px'}}
                             className={stylesSCTree['tree-indexed-search-item_button']}>
                            {/*<Button onClick={() => {
                        this._searchByValue(1);
                    }}>
                <FontAwesome
                    name={'search'}/>
                </Button>*/}
                            <Button style={{marginLeft: '2px'}} onClick={() => {
                                var specificFieldsValues = this.state.specificFieldsValues;
                                prefilledObjects[0][field.code].selected = [];
                                specificFieldsValues[field.code] = "";
                                this['specObject_' + field.code].getInstance().clear();
                                this.setState({specificFieldsValues, prefilledObjects});
                            }}>
                                <FontAwesome
                                    name={'close'}/>
                            </Button>
                        </div>
                    </>
                } else {
                    elementSearch = <FormControl
                        id={'indexed-value-search-' + fieldToId}
                        type={isDatePicker ? "number" : "text"}
                        style={{width: '100%'}}
                        placeholder={Dict.t(isDocument ? 'SEARCH_IN_DOCUMENTS' : 'SEARCH') + '...'}
                        value={isDatePicker ? this.state.selectedDate.from : (typeof this.state.specificFieldsValues[field.code] !== 'undefined' ? this.state.specificFieldsValues[field.code] : '')}
                        ref={(input) => {
                            this['indexSearch' + field.code] = input;
                        }}
                        disabled={typeof this.state.indexedValue !== 'undefined' && this.state.indexedValue !== ''}
                        onChange={(evt) => {
                            if (isDatePicker) {
                                var selectedDate = this.state.selectedDate;
                                selectedDate.from = evt.target.value;
                                this.setState({selectedDate})
                            } else {
                                var specificFieldsValues = this.state.specificFieldsValues;
                                var listItems = this.state.listItems;
                                if (evt.target.value.length > 0)
                                    specificFieldsValues[field.code] = evt.target.value;
                                else {
                                    delete specificFieldsValues[field.code];
                                }

                                this.setState({specificFieldsValues, listItems})
                            }
                        }
                        }
                        onKeyDown={(evt) => {
                            if (evt.keyCode === 13) {
                                this._searchByValue(1);
                            }
                        }}
                    />
                }

                if (this.layout === 2 && !this.isAllSearch) {
                    showIndexButton.push(<Button style={{marginRight: '5px'}} onClick={() => {
                        this._searchByValue(this.state.nPage, '___', false, fieldToId);
                    }}>
                        {Dict.t('SHOW_INDEX_BY') + " " + Dict.t(fieldToId)}
                    </Button>);
                }

                return <>{label}
                    <div
                        className={BUtils.joinClasses(stylesSCTree['input-group-indexed-search-complete'], additionalClassGroupIndexedSearchComplete)}>
                        <InputGroup
                            className={BUtils.joinClasses(stylesSCTree['input-group-indexed-search' + (isDatePicker ? '-date' : '')], (isDatePicker ? stylesSCTree['input-group-indexed-search-date--' + this.state.openSpecificDate] : ''))}>
                            <InputGroup.Addon key={"key-ref-create-entry"}
                                              style={{
                                                  fontWeight: 'bold',
                                                  minWidth: '170px',
                                                  fontSize: '12px',
                                                  height: '34px',
                                                  paddingTop: '9px',
                                                  textAlign: 'right',
                                                  paddingRight: '5px'
                                              }}>{addonLabel}</InputGroup.Addon>
                            {elementSearch}
                        </InputGroup>{additionalInputGroup}</div>
                </>
            });
        }

        var pagination = hasResult && this.state.pagItems.length > 1 ?
            <Pagination bsSize="small" style={{margin: '5px 10px 5px 0', verticalAlign: 'middle', display: 'block'}}
                        onSelect={this._handlePagination} key={'key-pagination'}>
                <Pagination.First onClick={() => this._handlePagination(1)} key={'key-pagination-first'}/>
                <Pagination.Prev
                    onClick={() => this._handlePagination(this.state.nPage > 1 ? this.state.nPage - 1 : -1)}
                    key={'key-pagination-prev'}/>
                {this.state.pagItems}
                {this.state.nPage < this.state.totalPages || true ?
                    <>
                        <span className={stylesSCTree['tree-indexed-search-total-items-container']}>
                            <span
                                className={stylesSCTree['tree-indexed-search-total-items-container__label']}>Tot.</span>
                            <span
                                className={stylesSCTree['tree-indexed-search-total-items-container__value']}>{this.state.totalItems}</span>
                        </span>
                        <Pagination.Next
                            onClick={() => this._handlePagination(this.state.nPage < this.state.totalPages ? this.state.nPage + 1 : -1)}
                            key={'key-pagination-next'}/>
                        <Pagination.Last onClick={() => this._handlePagination(this.state.totalPages)}
                                         key={'key-pagination-last'}>››&nbsp;({this.state.totalPages})</Pagination.Last>
                    </>
                    : ''}
            </Pagination> : '';


        return <div id={this.props.id} key={'key-' + this.props.id} style={{left: this.props.left}}
                    className={BUtils.joinClasses(stylesSCTree['tree-indexed-search-full--' + (this.props.indexedSearchOpen ? 'active' : 'inactive')], stylesSCTree['tree-indexed-search-all--' + hasIndexedSearchQuery])}>
            <Grid className={stylesSCTree['tree-indexed-search-item']} fluid>
                <Row id={this.props.id + '__header'}
                     className={BUtils.joinClasses(stylesSCTree['tree-item-search__title'], stylesSCTree['tree-minor-skin'])}>{hasIndexedSearchQuery ? (Dict.t('SEARCH') + ": '" + this.props.indexedSearchQuery + "' in " + this.state.additionalTitle) : Dict.t('INDEX_ADVANCED_SEARCH')}</Row>
                <Row className={BUtils.joinClasses(stylesSCTree['tree-indexed-item-search__body'])}>
                    <Col id={'tree-indexed-search-item__body-col-fields'} lg={5} md={5}
                         className={BUtils.joinClasses(stylesSCTree['tree-indexed-search-item__body-col-fields'], stylesSCTree['tree-main-skin'], stylesSCTree['tree-indexed-search-item__body-col-fields--' + !hasIndexedSearchQuery])}>
                        {this.layout === 1 ? <>
                            <div
                                className={BUtils.joinClasses(stylesSCTree['tree-indexed-search-item__body-col-fields__div'], stylesSCTree['tree-indexed-search-item__body-col-fields__first__div'])}>
                                <InputGroup style={{marginRight: '4px', width: '80%'}}>
                                    <FormControl
                                        id={'indexed-value-search'}
                                        type="text"
                                        placeholder={Dict.t(this.state.openSearchText ? 'DOCS_SEARCH' : 'ALL_FIELDS_SEARCH')}
                                        value={this.state.indexedValue}
                                        ref={(input) => {
                                            this.indexedSearch = input;
                                        }}
                                        onChange={(evt) => {
                                            var indexedValue = evt.target.value;
                                            this.setState({indexedValue});
                                        }}
                                        onKeyDown={(evt) => {
                                            if (evt.keyCode === 13) {
                                                this._searchByValue(1);
                                            }
                                        }}
                                    />
                                    <InputGroup.Addon style={{
                                        padding: '0 6px',
                                        height: '10px !important',
                                        position: 'absolute',
                                        right: '12px',
                                        zIndex: '1000',
                                        marginTop: '10px',
                                        backgroundColor: 'transparent',
                                        border: 0,
                                        cursor: 'pointer',
                                        opacity: '0.4'
                                    }}
                                                      onClick={() => {
                                                          this._emptySearch();
                                                          document.getElementById('indexed-value-search').focus();
                                                      }}><FontAwesome name={"times"}/></InputGroup.Addon>
                                </InputGroup>
                                <SCCheckbox
                                    checked={this.state.openSearchText}
                                    key={"key-chk-search-text-indexed"}
                                    additionalClass={stylesSCTree['chk-search-text-indexed']}
                                    label={Dict.t('DOCS_SEARCH')}
                                    tooltip={'cerca all\' interno di un documento'}
                                    id={"chk-search-text-indexed"}
                                    callbackParent={(id, newState) => {
                                        this._openSearchText(newState);
                                    }}/>

                            </div>
                            <div style={{textAlign: 'right', marginBottom: '35px'}}
                                 className={stylesSCTree['tree-indexed-search-item__body-col-fields__first__div']}>
                                <Button onClick={() => {
                                    this._searchByValue(1);
                                }}>
                                    {Dict.t('SEARCH')}
                                </Button>
                            </div>
                        </> : ''}
                        <div
                            className={BUtils.joinClasses(stylesSCTree['tree-indexed-search-item__body-col-fields__first__div'])}>
                            {!this.state.openSearchText && this.layout === 1 ? <><Button
                                className={stylesSCTree['button-indexed-search']}
                                onClick={() => {
                                    if (this.state.openSpecificObject)
                                        this._populateSpecificObjects();
                                    else
                                        this._performOpenSpecificObject();
                                }}>{Dict.t(this.state.openSpecificObject ? 'CLOSE_SPECIFIC_FIELDS' : 'SEARCH_SPECIFIC_FIELDS')}</Button>
                                {<Button
                                    className={BUtils.joinClasses(stylesSCTree['button-indexed-search'], stylesSCTree['button-indexed-search--' + this.state.hasDateFieldsOrNotSelected])}
                                    onClick={() => {
                                        this._openSpecificDate();
                                    }}>{Dict.t(this.state.openSpecificDate ? 'CLOSE_SEARCH_BY_DATE' : 'SEARCH_BY_DATE')}</Button>}</> : ''}
                            {this.layout === 1 ? <Typeahead
                                id={'tree-indexed-search-specific-obj'}
                                ref={(typeahead) => this.specObject}
                                clearButton
                                paginationText={Dict.t('DISPLAY_ADDITIONAL_RESULTS')}
                                className={BUtils.joinClasses(stylesSCTree['tree-indexed-search-specific-obj'], stylesSCTree['tree-indexed-search-specific-obj--' + this.state.openSpecificObject])}
                                onChange={selectedObject => {
                                    this._changeSpecificObject(selectedObject);
                                }}
                                onSearch={() => {
                                    return;
                                }}
                                options={this.state.specificObjects}
                                selected={this.state.selectedObject}
                                placeholder={Dict.t('COLLECTION')}
                            /> : ''}
                            {this.layout === 2 ? <>{showIndexButton}<h3
                                style={{marginTop: '25px', marginBottom: '15px'}}><Label
                                bsStyle="primary">{Dict.t('SEARCH_FIELDS')}</Label></h3></> : ''}
                            {selectedObjectFields}
                            {this.layout === 2 || true ? <div style={{textAlign: 'right', marginTop: '10px'}}
                                                              className={stylesSCTree['tree-indexed-search-item__body-col-fields__first__div']}>
                                <Button className={stylesSCTree['tree-item-show-legenda-buttons']} onClick={() => {
                                    this.setState({showLegenda: !this.state.showLegenda});
                                }}>
                                    {' ? '}
                                </Button>
                                <Button onClick={() => {
                                    this._searchByValue(1);
                                }}>
                                    {Dict.t('SEARCH')}
                                </Button>
                            </div> : ''}
                        </div>
                    </Col>
                    <Col lg={hasIndexedSearchQuery ? 12 : 7} md={hasIndexedSearchQuery ? 12 : 7}
                         className={stylesSCTree['tree-indexed-search-item__body-col-results']}>
                        <div id={'tree-indexed-search-item__body-col-results__overview'}
                             className={BUtils.joinClasses(stylesSCTree['tree-indexed-search-item__body-col-results__overview'], stylesSCTree['tree-indexed-search-item__body-col-results__overview--' + (hasResult)])}/>
                        <div id={this.props.id + '-tree-indexed-search-item__body-no-items-found'}
                             className={BUtils.joinClasses(stylesSCTree['tree-indexed-search-item__body-no-items-found'])}/>
                        <div className={stylesSCTree['sc-loading-info--' + this.state.loading]}>
                            <img className={stylesSCTree['sc-logo']}
                                 src={scLogo}/><span>{Dict.t('SEARCH_IN_PROGRESS_WAIT') + "..."}</span>
                        </div>
                    </Col>
                </Row>
                <Row
                    className={BUtils.joinClasses(stylesSCTree['tree-item-search_legenda'], stylesSCTree['tree-item-search_legenda--' + this.state.showLegenda])}>
                    <div className={BUtils.joinClasses(stylesSCTree['tree-item-search_legenda__text'])}>
                        <TreeAdvancedSearchLegenda/>
                    </div>
                    <div className={BUtils.joinClasses(stylesSCTree['tree-item-search_legenda__bar'])}>
                        <Button
                            onClick={() => {
                                this.setState({showLegenda: false});
                            }}
                        >{Dict.t('CLOSE')}</Button></div>
                </Row>
                <Row
                    className={BUtils.joinClasses(stylesSCTree['tree-item-search__footer'], stylesSCTree['tree-item-search__footer__doc--' + this.props.docsSearch])}>
                    {pagination}{filter}
                    <Button className={stylesSCTree['tree-item-advanced-search__bottom-buttons']} onClick={() => {
                        this._reset();
                        this.props.callbackCloseIndexedSearch();
                        this._showHideSearchFields(0);
                    }}><FontAwesome name={'times'}/></Button>
                </Row>
                <Modal id='tree-modal-doc-indexed-search' show={this.state.showDocument}
                       className={stylesSCTree["tree-modal-doc"]}
                       backdrop={'static'}
                       dialogClassName={stylesSCTree['tree-modal-doc__dialog']}
                       onHide={() => this.setState({showDocument: false})} restoreFocus>
                    <Modal.Header id={'tree-modal-doc-header'} className={stylesSCTree['tree-modal-doc__header']}/>
                    <Modal.Body id={'tree-modal-doc-body-indexed-search'}
                                className={stylesSCTree["tree-modal-doc__body"]}>
                    </Modal.Body>
                    <Modal.Footer><span id={'additional-tree-modal-doc-footer-items'}
                                        className={stylesSCTree['additional-tree-modal-doc-footer-items']}/>
                        <div id={'tree-modal-dynamic-buttons'} className={stylesSCTree['tree-modal-dynamic-buttons']}/>
                        <div id={'tree-modal-alignment-buttons'}
                             className={stylesSCTree['tree-modal-alignment-buttons']}/>
                        <Button
                            onClick={() => {
                                //var doc = {filename: '', src: '', pageNumber: 1, numbPages: -1};
                                this.setState({showDocument: false});
                            }}>{Dict.t('CLOSE')}</Button>
                    </Modal.Footer>
                </Modal>
            </Grid>
        </div>

    }

}